export const constant = {
	selector: {
		inlineEditElement: '[data-datagrid-editable-url][data-datagrid-editable-type="select"]',
	},
}
